import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PickerModule } from '@ctrl/ngx-emoji-mart';

import { TuainNgFormsLibModule } from 'tuain-ng-forms-lib';
import { CustomComponentsModule } from '../custom/custom-component.module';

import { AntdModule } from 'src/app/antd.module';

// Custom components based on forms
import { TerminalComponentForm } from './terminal/terminal.component';
import { TopbarComponent } from './top-bar/topbar.component';
import { TopbarMessagesComponent } from './messages/messages.component';
import { TopbarNotificationsComponent } from './notifications/notifications.component';

const COMPONENTS = [
  TerminalComponentForm,
  TopbarComponent,
  TopbarMessagesComponent,
  TopbarNotificationsComponent,
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    AntdModule,
    TranslateModule,
    NgScrollbarModule,
    FontAwesomeModule,
    NgxDropzoneModule,
    TuainNgFormsLibModule,
    CustomComponentsModule,
    PickerModule,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  bootstrap: [],
  schemas: [],
})
export class FormBasedComponentsModule { }
